import type { PageLoad } from './$types';

// export const csr = true;
export const load = (async ({ params }) => {
    let step, next;
    switch (params.step) {
        case 'general': step = 0; next = 'venue'; break;
        case 'venue': step = 1; next = 'work-entries'; break;
        case 'work-entries': step = 2; next = 'associated'; break;
        case 'associated': step = 3; next = 'additional'; break;
        case 'additional': step = 4; next = null; break;
        // case 'overview': step = 5; next = null; break;
        default: step = 0; next = 'venue'; break;

    }

    return {
        page_title: "New Projects",
        step,
        next
    };
}) satisfies PageLoad;

